"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import ScrollReveal from "@/components/ui/react-bits/ScrollReveal";

const LearnMore: React.FC = () => {
  return (
    <div className='flex flex-col items-center justify-center p-4 py-24 md:py-36'>
      <ScrollReveal
        textClassName='-my-[20px]! font-yellix text-center text-sm! leading-[110%]! font-medium tracking-[0%] lg:mx-56 md:text-[33px]!  md:font-semibold'
        baseOpacity={0}
        enableBlur={true}
        baseRotation={6}
        blurStrength={20}
      >
        We&rsquo;re reimagining the way credit works for government workers with less stress, more security, and greater
        balance. And a lot more trust.
      </ScrollReveal>

      <Link href='/shop' className='hidden'>
        <Button className='font-yellix mt-4 h-[28px] gap-0 rounded-full py-0 text-xs font-semibold duration-300 ease-in-out hover:scale-95 md:mt-12 md:h-[50px] md:w-[195px] md:text-sm'>
          <span>
            Learn more about Onyx
            <span className='text-link-primary'>.</span>
          </span>
        </Button>
      </Link>
    </div>
  );
};

export default LearnMore;
